<template>
    <div class="WarnView" id="WarnView">
        <WarnDetail
            :dialogWarnDetail="dialogWarnDetail"
            :warnArr.sync="warnArr"
            :totalSecond="totalSecond"
            :pageSecond="page"
            :measureNo="measureNo"
            :monitorParameter="monitorParameter"
            :type="type"
            :row="row"
            @changeEvent="changePage"
        ></WarnDetail>
        <div class="data_head">
                <el-date-picker
                    v-model="dates"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                ></el-date-picker>
                <el-button type="primary" @click.native="search()" class="searchButton">查&nbsp;询</el-button>
        </div>
        <div class="table tableContent" id="tableContent">
            <el-table :data="list" style="width: 100%;" :header-cell-style="{background:'#335ABB',color:'#FFF'}"
                      stripe :row-class-name="tableRowClassName">
                <el-table-column prop="monitorProject" label="检测项目"></el-table-column>
                <el-table-column prop="monitorParameter" label="参数"></el-table-column>
                <el-table-column prop="measureNo" label="测点编号"></el-table-column>
                <el-table-column prop="numberOfAlarms" label="预警次数">
                    <template slot-scope="scope">
                        <div>
                            {{ scope.row.warningTimes == 0 ? 0 : scope.row.warningTimes }}
                            <el-button class="searchButton" @click="warnDetail(scope.row,1)" type="mini" v-if="scope.row.warningTimes != 0">查 看</el-button>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="warningTimes" label="报警次数">
                    <template slot-scope="scope">
                        <div>
                            <span>{{ scope.row.numberOfAlarms == 0 ? 0 : scope.row.numberOfAlarms }}</span>
                            <el-button class="searchButton" @click="warnDetail(scope.row,2)" type="mini" v-if="scope.row.numberOfAlarms != 0">查 看</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page="pageNum"
              :page-size="pageSize"
              :hide-on-single-page="true"
              layout="total,prev, pager, next, jumper"
              :total="total"
              class="pagination"
              background
            ></el-pagination>
          </div>
        </div>

    </div>
</template>

<script>
import WarnDetail from "./WarnDetail";

export default {
    name: "WarnView",
    components: {
        WarnDetail,
    },
    data() {
        return {
            dates: [],
            total: null,
            dialogWarnDetail: { show: false },
            warnArr: [], // 详情数据
            totalSecond: null,
            measureNo: "",
            type: "",
            row:'',
            list: [],
            pageNum: 1,
            pageSize: 10,
            monitorParameter:'',
            page:1
        };
    },
    mounted: function () {
        let date = new Date();
        let month = ''
        let lastDay = ''
        let nextDay = ''
        if( (date.getMonth() + 1)<10){
            month='0'+(date.getMonth() + 1)
        } else{
            month=(date.getMonth() + 1)
        }
        if( (date.getDate() - 1)<10){
            lastDay='0'+ (date.getDate() - 1)
        }    else{
            lastDay=(date.getDate() - 1)
        }
        if( date.getDate()<10){
            nextDay='0'+ date.getDate()
        }else{
            nextDay= date.getDate()
        }
        if(this.$route.query.measureNo){
            this.dates=[this.$route.query.startDate,this.$route.query.endDate]
        }else{
            this.dates.push(
                date.getFullYear() +
                "-" +
                month +
                "-" +
                lastDay
            );
            this.dates.push(
                date.getFullYear() +
                "-" +
                month +
                "-" +
                nextDay
            );
        }


        if(this.$route.query.measureNo){
            this.getNew()
        }else {
            this.getDatas();
        }
    },
    methods: {
        getDatas() {
            this.$axios.get("/api/monitor/dataHistory/getPreAlarmRecord" +
                "?startTime=" + this.dates[0] + "&endTime=" + this.dates[1]+"&pageNum="+this.pageNum+"&version="+3)
                .then((res) => {
                    this.list = res.data.datas.values.list;
                    this.total = res.data.datas.values.total;
                });
        },
        getNew() {
            this.$axios.get("/api/monitor/dataHistory/getPreAlarmRecord" +
                "?startTime=" + this.dates[0] + "&endTime="+
                this.dates[1]+"&pageNum="+this.pageNum+"&version="+3+"&childProjectId="+this.$route.query.id+
                "&sMeasureNo="+this.$route.query.measureNo
            )
                .then((res) => {
                    this.list = res.data.datas.values.list;
                    this.total = res.data.datas.values.total;
                });
        },
        search() {
            if (this.dates == null) {
                this.$message({
                    message: "时间区间未选择",
                    type: "warning",
                });
                return;
            }
            if(this.$route.query.measureNo){
                this.getNew()
            }else{
                this.getDatas();
            }

        },
        handleCurrentChange(val) {
            if (this.dates == null) {
                this.$message({
                    message: "时间区间未选择",
                    type: "warning",
                });
                return;
            }
            this.pageNum = val;
            if(this.$route.query.measureNo){
                this.getNew()
            }else {
                this.getDatas();
            }
        },
        changePage(e,row,type){
            this.page=e
            this.changeNum(row,type)
        },
        changeNum(row, type){
            this.$axios.get(`/api/monitor/dataHistory/getWarnDetail?measureNo=${row.measureNo}
                        &startTime=${this.dates[0]}&endTime=${this.dates[1]}&alarmType=${type}&pageNum=${this.page}&version=3`).then((res) => {
                this.warnArr = res.data.datas.values.list;
                //参数
                this.measureNo = row.measureNo;
                this.monitorParameter = row.monitorParameter;
                //总数和分页
                this.totalSecond = res.data.datas.values.total;
            });
        },
        warnDetail(row, type) {
            this.row=row
            this.dialogWarnDetail.show = true;
            this.page=1
            this.$axios.get(`/api/monitor/dataHistory/getWarnDetail?measureNo=${row.measureNo}
                        &startTime=${this.dates[0]}&endTime=${this.dates[1]}&alarmType=${type}&pageNum=${this.page}&version=3`).then((res) => {
                this.warnArr = res.data.datas.values.list;
                //参数
                this.measureNo = row.measureNo;
                this.monitorParameter = row.monitorParameter;
                //总数和分页
                this.totalSecond = res.data.datas.values.total;
            });
        },
        //  拿到字段为“numberOfAlarms”和“warningTimes”的行数据，对其进行样式设置
        "tableRowClassName" : function(row) {
            if(row.row.numberOfAlarms != 0 || row.row.warningTimes != 0){
                return 'info-warn';
            }
            return
        },
    },
};
</script>


<style>
    #tableContent .el-table{
        color: #A7CCF6;
    }

    #tableContent .el-table .info-warn {
        color: red;
    }

    #tableContent .el-table__row {
        background-color: #0B3A68 !important;
    }

    #tableContent .el-table--striped .el-table__body tr.el-table__row--striped td{
        background-color: #021535;
    }

    #tableContent .el-table td{
        border: unset;
    }

    #tableContent .el-table th.is-leaf{
        border-bottom: none;
    }

    #WarnView .el-date-editor--daterange.el-input__inner{
        background-color: #3457DE;
    }

    #WarnView .el-date-editor .el-range-input{
        background-color: #3457DE;
        color: #FFF;
    }

    #WarnView .el-date-editor .el-range-separator{
        background-color: unset;
        color: #FFF;
    }

</style>

<style scoped>
  @import url('../../assets/css/style.css');

    .pagination {
        text-align: center;
    }

    .searchButton{
        margin-left: 30px;
        background-color: #E68F02;
        border: #E68F02;
        color: #FFF;
    }


</style>



// WEBPACK FOOTER //
// src/components/dataManage/warn-record.vue